import { useTranslation } from 'react-i18next'

import { LABEL_GETTER } from '../../../constants/option'
import { TagBar } from '../../TagBar'

import * as styles from './FilterValueTags.module.css'

function FilterValueTags({
  disabled,
  entity,
  filterOption,
  name,
  onClear,
  onClick,
}) {
  const { t } = useTranslation()

  function getText(option) {
    if (option.getText) {
      return option.getText()
    }

    const labelGetter = LABEL_GETTER[name] || LABEL_GETTER['common']

    const { isPersistent, isSystem, label, tObj } = labelGetter(option, entity)

    if (isPersistent || isSystem) {
      return t(label, tObj)
    }

    return label
  }

  return (
    <TagBar
      className={styles.tagBar}
      disabled={disabled}
      getText={getText}
      items={filterOption}
      onChange={onClick}
      onClear={onClear}
    />
  )
}

export default FilterValueTags
